module.exports = __webpack_public_path__ + "static/phos_logo-56b9d3aae7b97f1722e09b4009f8cf70.png";